import React, { Component } from "react";
import { FaSteam } from "react-icons/fa";
import { Link } from "react-router-dom";

import { GoogleColorIcon } from "../../components/GoogleColorIcon";
import AuthService from "../../services/auth";

import {
  API_BASE_URL,
  DATE_VOTE_FINISHED,
  PLAYER_WINNER,
  PLAYER_WINNER_NICK,
  PLAYER_WINNER_LINK,
  PLAYER_WINNER_TEAM,
  VOTE_YEAR,
} from "../../util/constants";

import "./styles.css";

class Login extends Component {
  constructor(props) {
    super(props);

    this.state = {
      userData: null,
    };
  }

  componentDidMount() {
    AuthService.getCurrentUserData().then((response) => {
      const { history } = this.props;

      const userData = response.data.data;

      this.setState({
        userData,
        isLoading: false,
      });

      if (userData.email || (userData.providerEmail && userData.displayName)) {
        history.push("/players");
      }
    });
  }

  render() {
    const now = new Date();
    const nowDate = new Date(now.getTime());
    const voteEndDate = new Date(new Date(DATE_VOTE_FINISHED).getTime());

    // console.log("nowDate:", nowDate);
    // console.log("voteEndDate:", voteEndDate);

    return (
      <div className="LoginContainer">
        <div className="Login">
          <img
            src="https://static.draft5.gg/jovem-do-ano/logo.png"
            width="400"
            alt="Logo"
          />
          {nowDate <= voteEndDate && (
            <>
              <h2 className="Login__title">Faça login para votar</h2>
              <div className="Login__buttons">
                <a
                  className={["Button", "Google"].join(" ")}
                  href={`${API_BASE_URL}/user/google`}
                >
                  <GoogleColorIcon width={18} />
                  Fazer login com o Google
                </a>
                <a
                  className={["Steam", "Button"].join(" ")}
                  href={`${API_BASE_URL}/user/steam`}
                >
                  <FaSteam size={18} />
                  Fazer login com a Steam
                </a>
              </div>
            </>
          )}
        </div>
        <div className="RulesContainer">
          <span className="RulesText">
            {nowDate >= voteEndDate &&
              PLAYER_WINNER &&
              PLAYER_WINNER_NICK &&
              PLAYER_WINNER_TEAM &&
              PLAYER_WINNER_LINK && (
                <>
                  <div className="winnerContainer">
                    <h1>
                      <span role="img" aria-label="troféu">
                        🏆
                      </span>
                      VENCEDOR
                    </h1>
                    <p>
                      O vencedor da edição {`${VOTE_YEAR}`} é{" "}
                      {`${PLAYER_WINNER.split(" ")[0]}`}{" "}
                      <b>"{`${PLAYER_WINNER_NICK}`}"</b>{" "}
                      {`${PLAYER_WINNER.split(" ")[1]}`} jogador da{" "}
                      <b>{`${PLAYER_WINNER_TEAM}`}</b>. Veja mais detalhes{" "}
                      <a
                        href={`${PLAYER_WINNER_LINK}`}
                        target="_blank"
                        rel="noreferrer"
                      >
                        clicando aqui
                      </a>
                      .
                    </p>
                  </div>
                  <hr />
                </>
              )}
            {nowDate >= voteEndDate &&
              !PLAYER_WINNER &&
              !PLAYER_WINNER_NICK &&
              !PLAYER_WINNER_TEAM &&
              !PLAYER_WINNER_LINK && (
                <>
                  <div className="winnerContainer">
                    <h1>
                      <span role="img" aria-label="troféu">
                        ⌛
                      </span>
                      VOTAÇÃO ENCERRADA
                    </h1>
                    <p>
                      A votação está encerrada. O resultado será anunciado em
                      breve. Fique ligado em nosso{" "}
                      <a
                        href="https://draft5.gg"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        site
                      </a>{" "}
                      e redes sociais.
                    </p>
                  </div>
                  <hr />
                </>
              )}
            <h1>
              O que é o <span>prêmio Matheus Queiroz jovem do ano</span>?
            </h1>
            <p>
              Visando homenagear <span>Matheus “brutt” Queiroz</span> e ainda
              criar um prêmio importante para a comunidade, adotamos a ideia da
              premiação do melhor jovem do ano.
            </p>
            <h2>Quem participa?</h2>
            <p>Jogadores menores de 20 anos.</p>
            <h2>Como é feita a escolha?</h2>
            <p>
              A equipe D5 preparou previamente uma lista de candidatos e o
              público decidirá integralmente quem será o vencedor.
            </p>
            <h2>QUAL A DIFERENÇA DE UM PRÊMIO DE REVELAÇÃO?</h2>
            <p>
              Geralmente o prêmio de revelação é dado ao jogador que teve um
              destaque atípico durante aquele ano, não tendo uma restrição de
              idade propriamente dita.
            </p>

            <h2>Votação</h2>
            <p>
              A votação pública se inicia no dia 02 de janeiro de 2026 e será
              finalizada no dia 15 de janeiro de 2026 às 23h59min.
            </p>

            <h2>Política de privacidade</h2>
            <p>
              Você pode conferir como seus dados são utilizados em nossa página
              de <Link to="/privacy">política de privacidade</Link>
            </p>
          </span>
        </div>
      </div>
    );
  }
}

export default Login;
